import { getParameterByName } from '@g/utils/index.js'
import reviewRecord from './reviewRecord'
import reviewComment from './reviewComment'
import reviewUser from './reviewUser'
import reviewCode from './reviewCode'
import reviewComplaint from './reviewComplaint'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review/create', params)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review/delete', params)
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review/update', params)
  },
  list ({ dispatch, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review/list', { params })
      .then(async (res) => {
        res.data.list = await dispatch('formatReview', res.data.list)
        return res
      })
  },
  userView ({ dispatch, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review/user-view', { params })
      .then(async (res) => {
        res.data.list = await dispatch('formatReview', res.data.list)
        return res
      })
  },
  view ({ dispatch, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review/view', { params })
      .then(async (res) => {
        if (res.data.model) {
          res.data.model = (await dispatch('formatReview', [res.data.model]))[0]
        }
        return res
      })
  },
  formatReview (_, list) {
    return list.map(item => {
      const images = typeof item.images === 'string' ? JSON.parse(item.images) : item.images
      const firstAspectRatio = getParameterByName('w', images[0]) / getParameterByName('h', images[0]) || 1
      const maxAspectRatio = Math.min(...images.map(img => getParameterByName('w', img) / getParameterByName('h', img))) || 1.7

      return {
        ...item,
        images,
        firstAspectRatio,
        maxAspectRatio,
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    reviewRecord,
    reviewComment,
    reviewUser,
    reviewCode,
    reviewComplaint,
  }
}
